import React from 'react';
import client from 'utils/client';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useToast } from 'components/Toast/useToast';
import './edit-terminal.css';
import TerminalForm from '../shared/TerminalForm';

function editTerminal(id, payload) {
  return client.put(`/terminals/${id}/update`, payload);
}

export default function EditTerminal() {
  const { state } = useLocation();
  const { id } = useParams();
  let navigate = useNavigate();
  const { onOpen } = useToast();
  const [terminal, setTerminal] = React.useState(state?.terminal || null);

  React.useEffect(() => {
    if (terminal) return;
    client.get(`/terminals/${id}`)
      .then((res) => setTerminal(res.data.data))
      .catch((err) => {
        onOpen({ type: 'error', message: err?.message || 'Failed to load terminal' });
        navigate('/terminals');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!terminal) {
    return <div className='new-terminal'><h1 className='add-terminal-title'>Edit Terminal</h1><p>Loading…</p></div>;
  }

  const initialValues = {
    merchantId: terminal.merchant_id ?? '',
    terminalId: terminal.terminal_id ?? '',
    terminalAgentName: terminal.agent_name ?? '',
    terminalAgentPhone: terminal.agent_phone ?? '',
    terminalLocation: terminal.location ?? '',
    terminalSerialNumber: terminal.serial_number ?? '',
    transactionLimit: terminal.transaction_limit ?? 0,
    feeRange: terminal.fee_range ?? 0,
    transactionFee: terminal.transaction_fee ?? 0,
    capRange: terminal.cap_range ?? 0,
    feeCap: terminal.fee_cap ?? 0,
    businessSegment: terminal.business_segment ?? '',
    settlementType: terminal.instant_settlement_enabled === true ? 'INSTANT': 'EOD',
    settlementProcess: terminal.settlement_process ?? '',
    terminalProviderId: terminal.terminal_provider_id ?? '',
    // Naira, same unit as the other fee fields. Empty means no charge.
    transferCharge: terminal.transfer_charge != null ? Number(terminal.transfer_charge) : '',
  };

  function handleSubmit(values) {
    // terminalProviderId is irreversible; strip it from update payload
    const { terminalProviderId, ...updatePayload } = values;
    return editTerminal(terminal.id, updatePayload)
      .then(() => {
        onOpen({ type: 'success', message: 'Updated Successfully' });
        navigate('/terminals');
      })
      .catch((err) => {
        onOpen({ type: 'error', message: err?.message || 'An Error Occured' });
      });
  }

  function toggleTerminal() {
    return editTerminal(terminal.id, {
      active: !terminal.active,
      feeRange: terminal.fee_range,
      transactionFee: terminal.transaction_fee,
      capRange: terminal.cap_range,
      feeCap: terminal.fee_cap,
      settlementType: terminal.instant_settlement_enabled === true ? 'INSTANT': 'EOD',
      settlementProcess: terminal.settlement_process,
    })
      .then(() => {
        onOpen({ type: 'success', message: 'Updated Successfully' });
        navigate('/terminals');
      })
      .catch((err) => {
        onOpen({ type: 'error', message: 'An Error Occured' });
        console.error(err);
      });
  }

  return (
    <div className='new-terminal'>
      <h1 className='add-terminal-title'>Edit Terminal</h1>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ isSubmitting }) => (
          <Form className='add-terminal-form'>
            <TerminalForm isEdit />
            <div className='edit-terminal-button-container'>
              <button type='submit' className='add-terminal-button' disabled={isSubmitting}>
                Edit
              </button>
              <button
                type='button'
                className={`disable-terminal-button ${terminal.active ? 'inactive' : ''}`}
                disabled={isSubmitting}
                onClick={toggleTerminal}>
                {terminal.active ? 'Disable' : 'Enable'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
